import { inject, type OnDestroy } from '@angular/core';
import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import type { UserBase } from '@core/account-types';
import { provide } from '@core/common-legacy';
import { I18nService } from '@core/i18n-legacy';
import type { MentionElement, MentionElementGroup } from '@core/prosemirror-legacy';
import { MentionsStream$ } from '@core/prosemirror-legacy/angular';

import { userToMention } from '../helpers';

@Injectable()
export class FilteredMentions$
  extends BehaviorSubject<MentionElement[] | MentionElementGroup[]>
  implements MentionsStream$, OnDestroy
{
  constructor() {
    super([]);
  }
  public ngOnDestroy() {
    this.complete();
  }
}

export const provideFilteredMentions = () => [
  provide(FilteredMentions$, { useClass: FilteredMentions$ }),
  provide(MentionsStream$, { useExisting: FilteredMentions$ }),
];

export const injectFilteredMentions = () => inject(FilteredMentions$);

export const injectSetRecruiteeFilteredMentions = () => {
  const i18n = inject(I18nService);
  const filteredMentions$ = injectFilteredMentions();
  return (allowedUsers: UserBase[], disallowedUsers: UserBase[]) => {
    const groupedMentions: MentionElementGroup[] = [
      { data: allowedUsers?.map(admin => userToMention(admin)) ?? [] },
      {
        header: i18n.translate('app.candidate.admin_select.no_access.header'),
        disabled: true,
        data:
          disallowedUsers?.map(user =>
            userToMention(user, {
              tooltip: i18n.translate(
                'app.candidate.admin_select.no_access.tooltip_share_on_the_go',
              ),
            }),
          ) ?? [],
      },
    ];
    filteredMentions$.next(groupedMentions);
  };
};
